import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    userAccount: {}
}


export const userAccountSlice = createSlice({
    name: "userAccount",
    initialState,
    reducers: {
        addUser: (state, action) => {
            state.userAccount = action.payload;
        }
    }
})

export const { addUser } = userAccountSlice.actions;

export default userAccountSlice.reducer;